import { CtxBodyAbstract } from './ctx-body-abstract';
import { DescrittoreSezione } from './descrittore-sezione';
import { FascicoloFull } from './fascicolo/fascicolo-full';

export class CtxBodyFascicolo extends CtxBodyAbstract {
  fascicolo: FascicoloFull;

  constructor(descrittori: DescrittoreSezione[], fascicolo: FascicoloFull) {
    super(descrittori);
    this.fascicolo = fascicolo;
  }
}
